import React from 'react'

import PropTypes from 'prop-types'

import './f-a-q.css'

const FAQ = (props) => {
  return (
    <div className={`f-a-q-accordion ${props.rootClassName} `}>
      <div
        data-role="accordion-container"
        className="f-a-q-element accordion-element"
      >
        <div className="f-a-q-details">
          <span className="f-a-q-text">How does ProSnapAI work?</span>
          <span data-role="accordion-content" className="f-a-q-text01">
            ProSnapAI uses advanced artificial intelligence technology to
            generate custom images based on your preferences. Simply input your
            desired style, colors, and other specifications, and our platform
            will generate a unique image that meets your needs.
            <span
              dangerouslySetInnerHTML={{
                __html: ' ',
              }}
            />
          </span>
        </div>
        <div data-role="accordion-icon" className="">
          <svg viewBox="0 0 1024 1024" className="f-a-q-icon">
            <path
              d="M366 708l196-196-196-196 60-60 256 256-256 256z"
              className=""
            ></path>
          </svg>
        </div>
      </div>
      <div
        data-role="accordion-container"
        className="f-a-q-element1 accordion-element"
      >
        <div className="f-a-q-details1">
          <span className="f-a-q-text02">
            What kind of images can I create with ProSnapAI?
          </span>
          <span data-role="accordion-content" className="f-a-q-text03">
            ProSnapAI can be used to create a variety of images, including
            product images, social media graphics, website banners, and more.
            With our customization options, the possibilities are endless.
            <span
              dangerouslySetInnerHTML={{
                __html: ' ',
              }}
            />
          </span>
        </div>
        <div data-role="accordion-icon" className="">
          <svg viewBox="0 0 1024 1024" className="f-a-q-icon02">
            <path
              d="M366 708l196-196-196-196 60-60 256 256-256 256z"
              className=""
            ></path>
          </svg>
        </div>
      </div>
      <div
        data-role="accordion-container"
        className="f-a-q-element2 accordion-element"
      >
        <div className="f-a-q-details2">
          <span className="f-a-q-text04">How much does ProSnapAI cost?</span>
          <span data-role="accordion-content" className="f-a-q-text05">
            We offer flexible pricing options to suit your needs, including
            pay-per-use, monthly subscriptions, and annual subscriptions. Our
            pricing is transparent and there are no hidden fees or charges.
            <span
              dangerouslySetInnerHTML={{
                __html: ' ',
              }}
            />
          </span>
        </div>
        <div data-role="accordion-icon" className="">
          <svg viewBox="0 0 1024 1024" className="f-a-q-icon04">
            <path
              d="M366 708l196-196-196-196 60-60 256 256-256 256z"
              className=""
            ></path>
          </svg>
        </div>
      </div>
      <div
        data-role="accordion-container"
        className="f-a-q-element3 accordion-element"
      >
        <div className="f-a-q-details3">
          <span className="f-a-q-text06">
            Can I use ProSnapAI for commercial purposes?
          </span>
          <span data-role="accordion-content" className="f-a-q-text07">
            Yes, you can use the images created with ProSnapAI for commercial
            purposes, including marketing campaigns, advertising, and other
            business applications.
            <span
              dangerouslySetInnerHTML={{
                __html: ' ',
              }}
            />
          </span>
        </div>
        <div data-role="accordion-icon" className="">
          <svg viewBox="0 0 1024 1024" className="f-a-q-icon06">
            <path
              d="M366 708l196-196-196-196 60-60 256 256-256 256z"
              className=""
            ></path>
          </svg>
        </div>
      </div>
      <div
        data-role="accordion-container"
        className="f-a-q-element4 accordion-element"
      >
        <div className="f-a-q-details4">
          <span className="f-a-q-text08">
            What kind of support is available if I have questions or issues?
          </span>
          <span data-role="accordion-content" className="f-a-q-text09">
            Our customer support team is available to help you with any
            questions or issues you may encounter while using ProSnapAI. We
            offer email support and will respond to your inquiries as quickly as
            possible.
            <span
              dangerouslySetInnerHTML={{
                __html: ' ',
              }}
            />
          </span>
        </div>
        <div data-role="accordion-icon" className="">
          <svg viewBox="0 0 1024 1024" className="f-a-q-icon08">
            <path
              d="M366 708l196-196-196-196 60-60 256 256-256 256z"
              className=""
            ></path>
          </svg>
        </div>
      </div>
    </div>
  )
}

FAQ.defaultProps = {
  rootClassName: '',
}

FAQ.propTypes = {
  rootClassName: PropTypes.string,
}

export default FAQ
